import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Subject } from '../types';
import { getSubjectAndGroupingColumns } from '../utils/subjectColumns';
import pallet from '../../../layouts/pallet';
import { StyledButton } from '../../Exams/styled';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import Icons from '../../../components/icons';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface SubjectTableAndActionsProps {
  onEdit: (subject: Subject) => void;
  onDelete: (subject: Subject) => void;
  onAddSubject: (value: boolean) => void;
  subjects: Subject[];
  isLoading: boolean;
}

const SubjectTableAndActions: React.FC<SubjectTableAndActionsProps> = ({
  onEdit,
  onDelete,
  onAddSubject,
  subjects,
  isLoading
}) => {
  const columns = getSubjectAndGroupingColumns(onEdit, onDelete);

  return (
    <PageWrapper sx={{ paddingTop: '16px !important' }}>
      <StyledButton
        onClick={() => onAddSubject(true)}
        sx={{ width: 'max-content', alignSelf: 'flex-end' }}
      >
        <Icons.PlusWhite style={{ marginRight: '6px' }} /> Add Subject
      </StyledButton>
      <DataGrid
        rowHeight={50}
        rows={subjects}
        columns={columns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        initialState={{
          ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
          columns: {
            ...columns,
            columnVisibilityModel: { id: false }
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default SubjectTableAndActions;
